<template>
  <div class="confirm">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div class="amount">
          <p>转账金额（美元）</p>
          <span v-if="transferData && transferData.amount">
            ${{ transferData.amount }}
          </span>
        </div>
        <div class="orderList">
          <ul>
            <li>
              <p>转账账号</p>
              <span v-if="transferData && transferData.fromAccount">{{ transferData.fromAccount.platformName }}</span>
            </li>
            <li>
              <p>收账账号</p>
              <span v-if="transferData && transferData.toAccount">{{ transferData.toAccount.platformName }}</span>
            </li>
          </ul>
        </div>
        <div
          class="submit"
          @click="submit"
        >
          <span>确认转账</span>
        </div>
        <div v-if="hasError" class="errMessage">
          <p>转账失败， 请联系客服！</p>
        </div>
      </div>
    </div>
    <Chat />
  </div>
</template>

<script>
require('@/assets/css/confirm.css')
import Header from '@/view/module/Header.vue'
import { mapState } from 'vuex'
import Chat from '@/view/module/Chat.vue'
import api from '@/plugins/api'

export default {
  name: 'PlatformTransferConfirm',
  components: { Header, Chat },
  computed: {
    ...mapState(['transferData'])
  },
  data() {
    return {
      title: '确认转账',
      rightContent: 'transfer',
      hasError: false
    }
  },
  methods: {
    submit() {
      const param = {
        fromPlatform: this.transferData.fromAccount.platform,
        toPlatform: this.transferData.toAccount.platform,
        amount: this.transferData.amount
      }

      this.$bus.$emit('loading', false)
      this.hasError = false
      api.addTransfer(this.$qs.stringify(param)).then(res => {
        this.$bus.$emit('loading', true)
        if (res.status) {
          if (res.data.code == 200) {
            this.$router.replace({
              path: '/home/platformTransferResult',
              query: {
                result: 'SUCCESS',
                // pno: 'TR241129B62158',
                // fromAccount: JSON.stringify(this.transferData.fromAccount),
                // toAccount: JSON.stringify(this.transferData.toAccount),
                createDate: new Date().toString(),
                amount: this.transferData.amount
              }
            })
          } else {
            this.hasError = true
          }
        }
      })
    }
  }
}
</script>
